/**
 * 堂食就餐人数选择
 */
import React, { useEffect, useState, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent, IonFooter } from '@ionic/react'
import { cartMobx } from 'restaurant'
import { SelectPerson, SelectKids } from './components/SelectNumber'
import { classNames, store } from '@dt/fe-utils'
import { showMsg } from '@utils'
import './index.scss'

interface IProps {
  config: IDiningNumConfig;
  reject?: (err: any) => void;
  resolve?: () => void;
}

const DiningPersonModal: React.FC<IProps> = ({ reject, resolve, config }) => {
  const [personNum, setPersonNum] = useState<number>(cartMobx.info.person || 0)
  const [kidNum, setKidNum] = useState<number>(cartMobx.info.kids || 0)
  const hasKids = useMemo(() => config.kids === 1, [config])
  // 就餐人数选择
  const handleSelect = (type, value) => {
    if (type === 'person') {
      setPersonNum(value)
    } else if (type === 'kids') {
      setKidNum(value)
    }
  }
  // 关闭弹层
  const handleClose = () => {
    if (!cartMobx.info.person) {
      showMsg(i18n.t('menu.diningNumber_no_person_tip'))
      return
    }
    reject('close')
  }
  // 确认选择
  const handleConfirm = () => {
    if (!personNum) {
      showMsg(i18n.t('menu.diningNumber_no_person_tip'))
      return
    }
    cartMobx.setJiuCanNum(personNum, kidNum)
    /** 缓存4小时 */
    store.set(`ls.diningPerson.${Config.BRANDID}.${Config.STOREID}`, { person: personNum, kids: kidNum, expired: Date.now() + 14400000 })
    resolve()
  }
  return (
    <IonModal
      isOpen
      swipeToClose
      cssClass='dining-person-modal'
    >
      <IonContent>
        <div className='dining-person-content-wrapper'>
          <div className='dining-person-header-wrapper'>
            <div className='dining-person-header'>
              <span>{i18n.t('cart.selectPerson')}</span>
              <i className='iconfont icon-close' onClick={handleClose}></i>
            </div>
            <div className='dining-person-tips'>{i18n.t(`cart.${hasKids ? 'personAndkids' : 'personNokids'}`)}</div>
          </div>
          <div className='select-wrapper'>
            <SelectPerson personNum={personNum} handle={handleSelect} hasKids={hasKids} />
          </div>
          <div className='select-wrapper'>
            <SelectKids kidNum={kidNum} height={config.kidsStandard} handle={handleSelect} hasKids={hasKids} />
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <div className='footer-container'>
          <button className={classNames('btn confirm', { disabled: !personNum })} onClick={() => handleConfirm()}>
            <span>{i18n.t('menu.diningNumber', { context: !personNum ? 'no_person' : (hasKids ? kidNum ? 'kids' : 'person' : 'once'), person: personNum, kids: kidNum })}</span>
          </button>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(DiningPersonModal)
